import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Loyalty System";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const CF_ENDPOINT_URL = env.CF_ENDPOINT_URL;
export const DOMAIN_URL = env.DOMAIN_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const PREVIEW_PATH = "/s";
export const UNAUTH_PREFIX_PATH = "/public";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "vi",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
};

export const DEFAULT_PAGINATION = {
  defaultPageSize: 10,
  total: 0,
  current: 1,
  pageSize: 10,
};
